import {
    FETCH_MESSAGES,
    FETCH_MESSAGES_SUCCESS,
    FETCH_MESSAGES_FAILED,
    SEND_MESSAGE,
    STOP_FETCH_MESSAGES
} from "../store/types";
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { RequestPushMsg } from '../other/NotificationFunctions';
import { onValue, push, off, child, update, ref } from "firebase/database";

export const fetchChatMessages = (bookingId) => (dispatch) => {

    const {
        chatRef
    } = firebase;
  
    dispatch({
        type: FETCH_MESSAGES,
        payload: bookingId,
    });
    onValue(chatRef(bookingId), snapshot => {
        if(snapshot.val()){
            let rootEntry = snapshot.val();
            let allMesseges = [];
            const currentUid = store.getState().auth.profile ? store.getState().auth.profile.uid : null;
            const updates = {};
            let hasUpdates = false;
            for (let key in rootEntry) {
                let entryKey = rootEntry[key]
                for (let msgKey in entryKey) {
                  entryKey[msgKey].smsId = msgKey
                  allMesseges.push(entryKey[msgKey])
                  if (currentUid && entryKey[msgKey].from !== currentUid && entryKey[msgKey].read !== true) {
                      updates[`chats/${bookingId}/messages/${key}/${msgKey}/read`] = true;
                      hasUpdates = true;
                  }
                }
            }
            if (hasUpdates) {
                update(ref(firebase.database), updates);
            }
            dispatch({
                type: FETCH_MESSAGES_SUCCESS,
                payload: allMesseges,
            });
        }else{
            dispatch({
                type: FETCH_MESSAGES_FAILED,
                payload: store.getState().languagedata.defaultLanguage.chat_not_found,
            });
        }
    })
};

export const sendMessage = (data) => (dispatch) => {
    console.log(`[chatactions] sendMessage triggered with message: "${data.message}", role: "${data.role}", bookingId: "${data.booking ? data.booking.id : 'undefined'}"`);

    const {
        chatRef
    } = firebase;

    const chatId = data.booking.customer + ','  + data.booking.driver
    var today = new Date();
    var time = today.getHours() + ":" + today.getMinutes();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); 
    var yyyy = today.getFullYear();
    today = mm + ':' + dd + ':' + yyyy;
    
    const msg = {
        message:data.message,
        from: data.role == 'customer'? data.booking.customer : data.booking.driver,
        type:"msg",
        msgDate:today,
        msgTime:time,
        createdAt: new Date().toString(),
        source: data.role,
        read: false
    };

    console.log(`[chatactions] Writing chat message to database node: chats/${data.booking.id}/messages/${chatId}`);
    push(child(chatRef(data.booking.id), chatId), msg);

    // Note: Client-side RequestPushMsg is commented out because chat notifications 
    // are now handled server-side via the chatNotification Cloud Function trigger.
    // This prevents duplicate notifications from being sent to the recipient.
    /*
    if(data.role == 'customer'){
        console.log(`[chatactions] Sender is customer. Target driver_token: "${data.booking.driver_token}"`);
        if(data.booking.driver_token){
            RequestPushMsg(
                data.booking.driver_token,
                {
                    title: store.getState().languagedata.defaultLanguage.notification_title  + store.getState().languagedata.defaultLanguage.chat_requested,
                    msg: data.message,
                    screen: 'onlineChat',
                    params: { bookingId: data.booking.id }
                });
        } else {
            console.warn(`[chatactions] Skipping client-side push notification because data.booking.driver_token is empty.`);
        }
    }else{
        console.log(`[chatactions] Sender is driver. Target customer_token: "${data.booking.customer_token}"`);
        if(data.booking.customer_token){
            RequestPushMsg(
                data.booking.customer_token,
                {
                    title: store.getState().languagedata.defaultLanguage.notification_title  + store.getState().languagedata.defaultLanguage.chat_requested,
                    msg: data.message,
                    screen: 'onlineChat',
                    params: { bookingId: data.booking.id}
                });
        } else {
            console.warn(`[chatactions] Skipping client-side push notification because data.booking.customer_token is empty.`);
        }
    }
    */

    dispatch({
        type: SEND_MESSAGE,
        payload: msg,
    });
}

export const stopFetchMessages = (bookingId) => (dispatch) => {

    const {
        chatRef 
    } = firebase;

    dispatch({
        type: STOP_FETCH_MESSAGES,
        payload: bookingId,
    });
    off(chatRef(bookingId));
}